import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { DeviceComponent } from '@app/features/device-health/pages/device.component';
import { Authority } from '@app/shared/utils/enums';

export const deviceRoutes: Routes = [
    {
        path: 'device',
        children: [
            {
                path: '',
                component: DeviceComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.LOGIN, Authority.RESTAURANT_VIEW, Authority.HELP_1, Authority.UPDATE],
                    reuse: true
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]